import { useRef, Fragment, useState, useCallback, useEffect } from "react";
import UI from "../../components/UI";
import Text from "../../libs/react-phaser-fiber/components/Text";
import Container from "../../libs/react-phaser-fiber/components/Container";
import usePhaser from "../../libs/react-phaser-fiber/hooks/usePhaser";
import { SCALE } from "../../utils/constants";
import Sprite from "../../libs/react-phaser-fiber/components/Sprite";
import { formatComp, formatScore } from "../../utils/helpers";
import { translate } from "../../utils/localization";
import { getNextLevel } from "../../components/LevelManager";
import { playResumeScore, stopResumeScore } from "../../utils/globalScore";
import * as Controller from "../../components/Controller/Controller";


const OptionsScene = () => {
  const { game, scene, sceneProps } = usePhaser();
  const [selIndex, setSelIndex] = useState(0);
  const [showRowScore, setShowRowScore] = useState(0);
  // const [results, setResults] = useState(null);
  const [options] = useState([
    translate("menu.main.score_op_next"),
    translate("menu.main.score_op_repeat"),
    translate("menu.main.score_op_exit"),
  ]);
  const tId = useRef();
  const refScene = useRef();

  const keyDownHandler = useCallback(
    (event) => {
      if (Controller.isCancel(event.key)) {
        game.scene.start("SplashScreenScene");
      }
      if (Controller.isDown(event.key) && selIndex < options.length - 1) {
        setSelIndex((idx) => idx + 1);
      }
      if (Controller.isUp(event.key) && selIndex > 0) {
        setSelIndex((idx) => idx - 1);
      }
      if (Controller.isConfirm(event.key)) {
        switch (selIndex) {
          default:
          case 0:
            scene.scene.start("GameScene", {
              levelName: getNextLevel(sceneProps?.level),
            });
            break;
          case 1:
            scene.scene.start("GameScene", { levelName: sceneProps?.level });
            break;
          case 2:
            scene.scene.start("MenuScene");
            break;
        }
      }
    },
    [game, scene, selIndex, options, sceneProps]
  );

  useEffect(() => {
    if (scene) {
      scene?.input.keyboard.addListener("keydown", keyDownHandler);
      playResumeScore(scene);
    }

    return () => {
      if (scene) {
        scene.input.keyboard.removeListener("keydown", keyDownHandler);
      }
    };
  }, [scene, keyDownHandler]);

  useEffect(() => {
    refScene.current = scene;
    scene?.anims.create({
      key: "arrow_menu",
      frames: scene.anims.generateFrameNumbers("hud", { frames: [30] }),
      repeat: 0,
    });
  }, [scene]);

  // useEffect(() => {
  //   if (sceneProps) {
  //     const data = dbManager.get(sceneProps.level);
  //     // console.log(sceneProps);
  //     setResults({
  //       ...data,
  //     });
  //   }
  // }, [sceneProps]);

  useEffect(() => {
    if (showRowScore < 5) {
      tId.current = setTimeout(() => setShowRowScore((v) => v + 1), 800);
    }
    return () => clearTimeout(tId.current);
  }, [showRowScore]);

  useEffect(() => {
    return () => {
      clearTimeout(tId.current);
      refScene.current.input.keyboard.off("keydown");
    };
  }, []);

  const formatFont = (txt) => {
    txt.displayHeight = 10 * SCALE;
    txt.depth = 16;
    txt.name = "header_text";
    txt.setScale(SCALE);
    txt.setScrollFactor(0);
    txt.setShadow(-1, 1);
  };
  const fontStyle = {
    fontFamily: "Emulogic",
    fontSize: "8px",
    fill: "#aee0c8",
    fontWeight: "regular",
  };

  const CONTAINER_TOP = UI.tileToScreen(1);
  const CONTAINER_LEFT = UI.tileToScreen(5);

  const MARGIN_LEFT = UI.tileToScreen(1);
  const LINE_HEIGHT = UI.tileToScreen(0.75);
  const MENU_OPTIONS_TOP = UI.tileToScreen(7);

  return (
    <Container x={CONTAINER_LEFT} y={CONTAINER_TOP}>
      <Text
        x={MARGIN_LEFT}
        y={0}
        setStyle={fontStyle}
        addedToScene={formatFont}
      >
        {`KI - ${sceneProps?.level.includes('maze') ? translate("menu.main.ruins") : translate("menu.main.chamber")} ${sceneProps?.level.replace(
          /level_|maze_/,
          ""
        )} ${sceneProps?.level.includes('maze') ? "" : translate("menu.main.of") + " 19"}`}
      </Text>
      {showRowScore > 0 && (
        <Fragment key="gems_score">
          <Text
            x={MARGIN_LEFT}
            y={LINE_HEIGHT * 2}
            setStyle={fontStyle}
            alpha={
              sceneProps?.collectedDiamonds < sceneProps?.countDiamonds
                ? 0.8
                : 1
            }
            addedToScene={formatFont}
          >
            {translate("menu.main.score_gems")}
          </Text>
          <Text
            x={MARGIN_LEFT + UI.tileToScreen(6)}
            y={LINE_HEIGHT * 2}
            setStyle={fontStyle}
            alpha={
              sceneProps?.collectedDiamonds < sceneProps?.countDiamonds
                ? 0.8
                : 1
            }
            addedToScene={formatFont}
          >
            {formatScore(
              sceneProps?.collectedDiamonds,
              sceneProps?.countDiamonds
            )}
          </Text>
        </Fragment>
      )}
      {showRowScore > 1 && (
        <Fragment key="enemies_score">
          <Text
            x={MARGIN_LEFT}
            y={LINE_HEIGHT * 3}
            setStyle={fontStyle}
            alpha={
              sceneProps?.killedEnemies < sceneProps?.countEnemies ? 0.8 : 1
            }
            addedToScene={formatFont}
          >
            {translate("menu.main.score_enemies")}
          </Text>
          <Text
            x={MARGIN_LEFT + UI.tileToScreen(6)}
            y={LINE_HEIGHT * 3}
            setStyle={fontStyle}
            alpha={
              sceneProps?.killedEnemies < sceneProps?.countEnemies ? 0.8 : 1
            }
            addedToScene={formatFont}
          >
            {formatScore(sceneProps?.killedEnemies, sceneProps?.countEnemies)}
          </Text>
        </Fragment>
      )}
      {showRowScore > 2 && (
        <Fragment key="shrooms_score">
          <Text
            x={MARGIN_LEFT}
            y={LINE_HEIGHT * 4}
            setStyle={fontStyle}
            alpha={
              sceneProps?.collectedShrooms < sceneProps?.countShrooms ? 0.8 : 1
            }
            addedToScene={formatFont}
          >
            {translate("menu.main.score_shrooms")}
          </Text>
          <Text
            x={MARGIN_LEFT + UI.tileToScreen(6)}
            y={LINE_HEIGHT * 4}
            setStyle={fontStyle}
            alpha={
              sceneProps?.collectedShrooms < sceneProps?.countShrooms ? 0.8 : 1
            }
            addedToScene={formatFont}
          >
            {formatScore(
              sceneProps?.collectedShrooms,
              sceneProps?.countShrooms
            )}
          </Text>
        </Fragment>
      )}

      <Text
        x={MARGIN_LEFT}
        y={LINE_HEIGHT * 4.75}
        setStyle={fontStyle}
        addedToScene={formatFont}
      >
        --------------------
      </Text>
      {showRowScore > 3 && (
        <Fragment key="total_score">
          <Text
            x={MARGIN_LEFT}
            y={LINE_HEIGHT * 5.5}
            setStyle={fontStyle}
            alpha={sceneProps?.comp <= sceneProps?.prevBest ? 0.8 : 1}
            addedToScene={formatFont}
          >
            {translate("menu.main.score_comp")}
          </Text>
          <Text
            x={MARGIN_LEFT + UI.tileToScreen(6)}
            y={LINE_HEIGHT * 5.5}
            setStyle={fontStyle}
            alpha={sceneProps?.comp <= sceneProps?.prevBest ? 0.8 : 1}
            addedToScene={formatFont}
          >
            {formatComp(sceneProps?.comp)}
          </Text>
        </Fragment>
      )}
      {showRowScore > 4 && (
        <Fragment key="best_score">
          <Text
            x={MARGIN_LEFT}
            y={LINE_HEIGHT * 6.5}
            setStyle={{
              ...fontStyle,
              fill:
                sceneProps?.prevBest >= sceneProps?.comp
                  ? "#aee0c8"
                  : "#ffd700",
            }}
            addedToScene={formatFont}
          >
            {translate("menu.main.score_best")}
          </Text>
          <Text
            x={MARGIN_LEFT + UI.tileToScreen(6)}
            y={LINE_HEIGHT * 6.5}
            setStyle={{
              ...fontStyle,
              fill:
                sceneProps?.prevBest >= sceneProps?.comp
                  ? "#aee0c8"
                  : "#ffd700",
            }}
            addedToScene={formatFont}
          >
            {formatComp(Math.max(sceneProps?.prevBest, sceneProps?.comp))}
          </Text>
        </Fragment>
      )}
      {options.map((label, idx) => (
        <Fragment key={`row_${idx}`}>
          {selIndex === idx && (
            <Sprite
              args={[100, 100, "arrow"]}
              x={MARGIN_LEFT - UI.tileToScreen(1.3)}
              y={MENU_OPTIONS_TOP + LINE_HEIGHT * idx + UI.tileToScreen(0.15)}
              addedToScene={(el) =>
                el
                  ?.play("arrow_menu")
                  .setRotation(-Math.PI / 2)
                  .setScale(SCALE)
                  .setOrigin(0.5, 0)
              }
            />
          )}
          <Text
            alpha={selIndex === idx ? 1 : 0.5}
            args={[
              MARGIN_LEFT,
              MENU_OPTIONS_TOP + LINE_HEIGHT * idx,
              label,
              {
                fontFamily: "Emulogic",
                fontSize: "8px",
                fill: "#aee0c8",
                fontWeight: "regular",
              },
            ]}
            addedToScene={formatFont}
          />
        </Fragment>
      ))}
    </Container>
  );
};

export default OptionsScene;
